'use client';

import React from 'react';
import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import FadeIn from '@/components/FadeIn';
import DefaultButton from '@/components/DefaultButton';

const WIDTH = 325;
const BALL_WIDTH = 75;

const SpringVsEase = () => {
  const [ratio, setRatio] = React.useState(0);

  const transform = `translateX(${ratio ? ratio * WIDTH - BALL_WIDTH : 0}px)`;

  const spring = useSpring({
    transform,
    config: {
      mass: 2,
      tension: 100,
      friction: 26,
    },
  });

  return (
    <FadeIn delay={500} duration={750}>
      <Wrapper style={{ width: WIDTH, height: 280 }}>
        <Track>
          <CssBall
            style={{
              transform,
            }}
          ></CssBall>
        </Track>
        <Track>
          <Ball as={animated.div} style={spring}></Ball>
        </Track>
        <DefaultButton onClick={() => setRatio(Math.abs(1 - ratio))}>
          Toggle Animation
        </DefaultButton>
      </Wrapper>
    </FadeIn>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const Track = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--color-gray-100);
  margin-bottom: 32px;
`;

const Ball = styled.div`
  width: ${BALL_WIDTH}px;
  height: ${BALL_WIDTH}px;
  border-radius: 50%;
  background: var(--color-secondary);
  will-change: transform;
`;

const CssBall = styled(Ball)`
  transition: transform 800ms;
`;

const BallImg = styled.img`
  display: block;
  width: 100%;
`;

export default SpringVsEase;
